import { ScanSearch, Wrench, Brain } from "lucide-react";

const STEPS = [
    {
        icon: ScanSearch,
        step: "01",
        title: "Prozess analysieren",
        text: "Wir schauen gemeinsam, wo in Ihrem Unternehmen die Zeit verloren geht: eingehende Anfragen, Dokumente, Termine, Dateneingabe. Kein Workshop-Marathon – ein ehrliches Gespräch reicht meist.",
        testid: "solution-step-1",
    },
    {
        icon: Wrench,
        step: "02",
        title: "Automatisierung maßschneidern",
        text: "Wir bauen eine KI-Automatisierung, die zu Ihren Abläufen passt: Anfragen erkennen und beantworten, Dokumente verarbeiten, Termine koordinieren. Angebunden an Ihre bestehenden Systeme – kein IT-Großprojekt.",
        testid: "solution-step-2",
    },
    {
        icon: Brain,
        step: "03",
        title: "Kopf frei fürs Kerngeschäft",
        text: "Ihr Team sieht nur noch, was wirklich einen Menschen braucht. Der Rest läuft im Hintergrund – zuverlässig, dokumentiert, jeden Tag. Die gewonnene Zeit geht in Aufträge und Kunden.",
        testid: "solution-step-3",
    },
];

export const Solution = () => (
    <section id="funktionsweise" className="py-20 lg:py-28 bg-[#111827] border-t border-white/[0.06] scroll-mt-16" aria-labelledby="solution-heading">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="font-mono-label text-xs uppercase tracking-[0.2em] text-emerald-400">So funktioniert's</p>
            <h2 id="solution-heading" className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-white max-w-2xl">
                Drei Schritte. Maßgeschneidert statt von der Stange.
            </h2>
            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
                {STEPS.map(({ icon: Icon, step, title, text, testid }) => (
                    <article key={testid} data-testid={testid} className="relative rounded-2xl border border-white/[0.08] bg-[#0B0F17] p-6 sm:p-8">
                        <span className="font-mono-label text-xs text-emerald-500/70 tracking-[0.2em]" aria-hidden="true">
                            {step}
                        </span>
                        <div className="mt-4 flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-500/10 border border-emerald-500/20">
                            <Icon className="h-5 w-5 text-emerald-400" aria-hidden="true" />
                        </div>
                        <h3 className="mt-6 text-xl font-medium text-white">{title}</h3>
                        <p className="mt-3 text-sm text-[#9CA3AF] leading-relaxed">{text}</p>
                    </article>
                ))}
            </div>
        </div>
    </section>
);
